import { PostgrestError } from '@supabase/supabase-js';

export class ProviderServiceError extends Error {
    constructor(
        message: string,
        public code: string,
        public originalError?: PostgrestError
    ) {
        super(message);
        this.name = 'ProviderServiceError';
    }
} 